module.exports = __webpack_public_path__ + "static/media/portfolio7-5.18854982.png";